import { useRouteLoaderData } from '@remix-run/react'
import type { RootDataProps } from '~/types'

export type EnvKey = keyof NonNullable<RootDataProps['env']>

const toBoolean = (value: unknown): boolean => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase()
    if (['true', '1', 'yes', 'y', 'on'].includes(v)) return true
    if (['false', '0', 'no', 'n', 'off', ''].includes(v)) return false
  }
  return false
}

const useRootEnvBoolean = (envKey: EnvKey) => {
  const { env } = useRouteLoaderData('root') as RootDataProps
  return toBoolean(env?.[envKey])
}

export default useRootEnvBoolean
